"use client";

import Script from "next/script";
import { env } from "@/lib/environment";

interface ThinkstackChatbotProps {
  chatbotId: string;
}

export default function ThinkstackChatbot({ chatbotId }: ThinkstackChatbotProps) {
  // Use the centralized environment configuration, note env.NEXT_PUBLIC_THINKSTACK_API_URL already has fallback
  const scriptUrl = `${env.NEXT_PUBLIC_THINKSTACK_API_URL}/bot/thinkstackai-loader.min.js`;

  // The event listener logic from the original component
  const onReady = `
    if (window.thinkstackai) {
      window.thinkstackai.addEventListener("CONTACT_SALES", function () {
        if (window.$zoho?.salesiq?.chat) {
          window.$zoho.salesiq.floatwindow.visible("show")
        }
        if (window.thinkstackai?.close) {
          window.thinkstackai.close();
        }
      });
    }
  `;

  // The CSS injection logic from the original component
  const cssInjection = `
    (function(){
      var existing = document.getElementById("thinkstack-chat-style");
      if (!existing) {
        var st = document.createElement("style");
        st.id = "thinkstack-chat-style";
        document.head.appendChild(st);
        if (st.sheet && st.sheet.insertRule) {
          st.sheet.insertRule("#thinkstack-chat-window{z-index:9999!important}", 0);
        } else {
          st.appendChild(document.createTextNode("#thinkstack-chat-window{z-index:9999!important}"));
        }
      }
    })();
  `;

  return (
    <>
      {/*
        The core Thinkstack script.
        We'll use a `lazyOnload` strategy since this is a non-critical chatbot.
        This ensures it won't block the initial page render.
      */}
      <Script
        id="thinkstack-chatbot-script"
        src={scriptUrl}
        strategy="lazyOnload" // Key optimization: loads after the main content
        data-type="default"
        // @ts-ignore
        chatbot_id={chatbotId}
      />

      {/*
        A separate inline script to handle the event listener and CSS injection.
        We also use `lazyOnload` for this script to ensure it runs after the main
        chatbot script is loaded.
      */}
      <Script
        id="thinkstack-chatbot-init"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            // Inject CSS immediately
            ${cssInjection}

            // Wait for the chatbot to be ready and then set up the listener
            document.addEventListener("thinkstackai:ready", function() {
              ${onReady}
            });
          `,
        }}
      />
    </>
  );
}
